import { IDetectedBarcode, Scanner } from "@yudiel/react-qr-scanner";

type qrScannerType = {
  handleScan: (result: IDetectedBarcode[]) => void;
};

const QrScanner: React.FC<qrScannerType> = ({ handleScan }) => {
  return (
    <Scanner
      onScan={(result) => {
        handleScan(result);
      }}
      allowMultiple
      constraints={{ facingMode: "environment" }}
      components={{ finder: false, zoom: true }}
      scanDelay={4000}
    />
  );
};

export default QrScanner;
